import Vapor from 'laravel-vapor';

const uploads = new Map();

export const uploadFilesToS3 = formData => {
    const files = getFiles(formData);

    if (files.length > 0) {
        return Promise.all(
            files.map(([name, file]) => uploadFileToS3(name, file)),
        ).then(entries => {
            // Remove file objects from FormData
            entries.forEach(entry => formData.delete(entry.form_key));

            // Add s3 file info in place of file objects
            entries.forEach(entry =>
                formData.append(entry.form_key, JSON.stringify(entry)),
            );

            return formData;
        });
    } else {
        return Promise.resolve(formData);
    }
};

const isFile = val =>
    typeof val === 'object' && val instanceof File && val.size > 0 && val.name;

const getFiles = formData => {
    if (!(formData instanceof FormData)) {
        return [];
    }

    const files = [];
    for (const [key, val] of formData.entries()) {
        if (isFile(val)) {
            files.push([key, val]);
        }
    }
    return files;
};

export const uploadFileToS3 = (key, file) => {
    if (uploads.has(file)) {
        return uploads.get(file);
    }

    const promise = Vapor.store(file).then(response => ({
        type: 's3-file',
        name: file.name,
        form_key: key,
        s3_key: response.key,
        uuid: response.uuid,
    }));

    uploads.set(file, promise);

    return promise;
};
